import { AppSuccess } from '../../models/AppSuccess';
import { Organization_Base } from '../../models/Organization';
import { User_Base } from '../../models/User';
import { AC_Description } from './AC_Type';

// ACL configuration
export enum AC_Organization_Role {
  ORGANIZATION_OWNER = 'ORGANIZATION_OWNER',
  ORGANIZATION_ADMIN = 'ORGANIZATION_ADMIN',
  ORGANIZATION_EDITOR = 'ORGANIZATION_EDITOR',
  ORGANIZATION_MEMBER = 'ORGANIZATION_MEMBER',
}

export enum AC_Organization_Permission {
  MANAGE_PROJECT = 'MANAGE_PROJECT',
  MANAGE_ORG_INFO = 'MANAGE_ORG_INFO',
  MANAGE_USER = 'MANAGE_USER',
}

export const AC_Organization_RolePermission = {
  ORGANIZATION_OWNER: ['MANAGE_PROJECT', 'MANAGE_ORG_INFO', 'MANAGE_USER'],
  ORGANIZATION_ADMIN: ['MANAGE_PROJECT', 'MANAGE_ORG_INFO', 'MANAGE_USER'],
  ORGANIZATION_EDITOR: ['MANAGE_PROJECT', 'MANAGE_ORG_INFO'],
  ORGANIZATION_MEMBER: ['MANAGE_PROJECT'],
};

// API types
export type AC_Organization_getMyRoles_Request_Query = {
  organizationId: number;
};
export type AC_Organization_getMyRoles_Response = Array<AC_Organization_Role>;

///
export type AC_Organization_getUsersWithRoles_Request_Query = {
  organizationId: number;
  userId?: number;
};

export type AC_Organization__User_with_Roles = {
  user: User_Base;
  roles: Array<AC_Organization_Role>;
};
export type AC_Organization_getUsersWithRoles_Response = Array<AC_Organization__User_with_Roles>;
///

export type AC_Organization_getMyPermissions_Request_Query = {
  organizationId: number;
};
export type AC_Organization_getMyPermissions_Response = Array<AC_Organization_Permission>;

export type AC_Organization_Base = {
  user?: User_Base;
  organization?: Organization_Base;
  role: AC_Organization_Role;
};
export type AC_Organization_addRoleForUser_Request = {
  userId: number;
  organizationId: number;
  role: AC_Organization_Role;
};
export type AC_Organization_addRoleForUser_Response = AppSuccess<AC_Organization_Role>;

export type AC_Organization_deleteRoleForUser_Request_Query = {
  userId: number;
  organizationId: number;
  role: AC_Organization_Role;
};
export type AC_Organization_deleteRoleForUser_Response = AppSuccess<AC_Organization_Base>;

// Utils

const getRoleName = (role: AC_Organization_Role): string => {
  switch (role) {
    case AC_Organization_Role.ORGANIZATION_OWNER:
      return 'Chủ sở hữu';
    case AC_Organization_Role.ORGANIZATION_ADMIN:
      return 'Quản trị viên';
    case AC_Organization_Role.ORGANIZATION_EDITOR:
      return 'Biên tập viên';
    case AC_Organization_Role.ORGANIZATION_MEMBER:
      return 'Nhân viên';
    default:
      return '-';
  }
};
const getRoleDescription = (role: AC_Organization_Role): AC_Description => {
  switch (role) {
    case AC_Organization_Role.ORGANIZATION_ADMIN:
      return { en: 'full access in the project', vi: 'toàn quyền đổi với dự án' };
    case AC_Organization_Role.ORGANIZATION_EDITOR:
      return { en: 'full access, but cannot manage user', vi: 'toàn quyền, nhưng không thể quản lý người dùng' };
    default:
      return { en: 'unknown role', vi: 'role không đúng' };
  }
};

const getPermissionDescription = (permission: AC_Organization_Permission): AC_Description => {
  switch (permission) {
    case AC_Organization_Permission.MANAGE_PROJECT:
      return { en: 'manage project information', vi: 'quản lý dự án' };
    case AC_Organization_Permission.MANAGE_USER:
      return { en: 'manage user', vi: 'quản lý người dùng của workspace' };
    default:
      return { en: 'unknown role', vi: 'role không đúng' };
  }
};

const getPermissions = (roles: Array<AC_Organization_Role>): Array<AC_Organization_Permission> => {
  let permissionsSet = new Set<AC_Organization_Permission>();

  for (let i = 0; i < roles.length; i++) {
    let role = roles[i];
    let permissions = AC_Organization_RolePermission[role];
    permissions.forEach((permission) => {
      permissionsSet.add(permission as AC_Organization_Permission);
    });
  }

  return Array.from(permissionsSet);
};

export const AC_Organization = {
  getRoleName,
  getRoleDescription,
  getPermissionDescription,
  getPermissions,
};
